import type { ReactNode } from 'react';
import { Logo } from '@/components/Logo';

/** Signed-out pages (accept invite): same look as the themed login page (§10.3). */
export function PublicCardLayout({ children }: { children: ReactNode }): JSX.Element {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4 py-10">
      <div className="w-full max-w-sm">
        <div className="mb-6 text-center">
          <h1 className="inline-flex">
            <Logo size="lg" />
          </h1>
          <p className="mt-1 text-sm text-muted-foreground">Skaleminds Internal</p>
        </div>
        <div className="card p-6">{children}</div>
      </div>
    </div>
  );
}
